import { FC, memo } from 'react';

import { FileIconState, IChatFileIconProps } from '../FileIcon.types';
import { getFileIconComponent } from '../FileIcon.utils';

export const FileIconChat: FC<IChatFileIconProps> = memo((props) => {
  const { state = FileIconState.Regular, onCancel } = props;

  const commonProps = { onCancel };
  const Component = getFileIconComponent(props.type, state);

  return <Component {...commonProps} />;
});
